import { IntlShape } from 'react-intl';

import { OrganisationListItem } from '@futrli-sdk/workspaces';

/**
 * Returns the label for a given billed by status
 * @param billedByStatus - The billed by status of the organisation
 * @param intl - The react-intl object used for internationalization
 */
export const getBillByStatusLabel = (billedByStatus: OrganisationListItem['billed_by_status'], intl: IntlShape) => {
  switch (billedByStatus) {
    case 'blocked':
      return intl.formatMessage({ id: 'common.blocked', defaultMessage: 'Blocked' });
    case 'active':
      return intl.formatMessage({ id: 'common.active', defaultMessage: 'Active' });
    case 'cancelled':
      return intl.formatMessage({ id: 'common.cancelled', defaultMessage: 'Cancelled' });
    case 'expired':
      return intl.formatMessage({ id: 'common.expired', defaultMessage: 'Expired' });
    case 'nolicense':
      return intl.formatMessage({ id: 'common.no_license', defaultMessage: 'No Licence' });
    case 'pending':
      return intl.formatMessage({ id: 'common.pending', defaultMessage: 'Pending' });
    case 'reset':
      return intl.formatMessage({ id: 'common.reset', defaultMessage: 'Reset' });
    case 'not_active':
      return intl.formatMessage({ id: 'common.not_active', defaultMessage: 'Not Active' });
    default:
      return '';
  }
};
